import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import ReviewStars from '@src/quince-components/src/atoms/reviews/reviewStars'

import {
  reviewCountCss,
  reviewRatingCss,
  reviewStarIconCss,
  reviewWrapperCss,
  reviewWrapperUpdatedDesignV2Css,
} from './product-info-ds.styles'

export interface ProductInfoReviewSummaryDSProps {
  avgRating?: number
  reviewCount?: number
  onReviewSummaryClick?: (e: React.MouseEvent<HTMLElement>) => void
  hideReviewCount?: boolean
  hideReviewLabel?: boolean
  productInfoReviewClassName?: string
  hideReviewSummary?: boolean
  updatedDesignForV2?: boolean
}

const ProductInfoReviewSummaryDS = ({
  avgRating,
  reviewCount,
  onReviewSummaryClick,
  hideReviewCount,
  hideReviewLabel,
  productInfoReviewClassName,
  hideReviewSummary,
  updatedDesignForV2,
}: ProductInfoReviewSummaryDSProps) => {
  const { t } = useTranslation('common')

  if (hideReviewSummary || !avgRating || Number(reviewCount) <= 0) {
    return null
  }

  return (
    <div
      className={cx(reviewWrapperCss, updatedDesignForV2 && reviewWrapperUpdatedDesignV2Css)}
      onClick={onReviewSummaryClick}
    >
      <ReviewStars
        totalStars={5}
        fillStars={avgRating}
        className={cx(reviewRatingCss)}
        classNameIcon={reviewStarIconCss}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
        starSvg={undefined}
      />
      {reviewCount && !hideReviewCount && (
        <p
          data-testid={TEST_LOCATORS.FIRST_FOLD_REVIEW_COUNT}
          className={cx(reviewCountCss, productInfoReviewClassName)}
        >
          (
          <span>
            {reviewCount}
            {!hideReviewLabel && <>&nbsp;{reviewCount === 1 ? t('review') : t('reviews_v1')}</>}
          </span>
          )
        </p>
      )}
    </div>
  )
}

export default ProductInfoReviewSummaryDS
